import React from "react";
import { Balance } from "./Dashboard/Balance";
import { Sales } from "./Dashboard/Sales";
import { TotalEarnings } from "./Dashboard/TotalEarnings";
import { MyProduct } from "./MyProduct";
import { BestSellers } from "./Dashboard/BestSellers";
import ChartComponent from "./Dashboard/ChartComponent";
import { Status } from "./Dashboard/Status";
import BarComponent from "./Dashboard/BarComponent";
import { Countries } from "./Dashboard/Countries";

export const AuthorDashboard = () => {
  return (
    <div className="lg:px-6 py-4">
      <div className="flex space-x-4 overflow-x-scroll hidescroll">
        <Balance />
        <Sales />
        <TotalEarnings />
      </div>
      <div className="2xl:flex 2xl:space-x-4 ">
        <div className="w-full">
          <ChartComponent type={'linear'} />
          <BestSellers />
        </div>
        <div className="w-full 2xl:w-1/2">
          <Status />
          <Countries/>
          <BarComponent type={'bar'} />
        </div>
      </div>
    </div>
  );
};
